export default [
  '$timeout',
  function focusDirective($timeout) {
    return {
      link: function(scope, element, attrs) {
        scope.$watch(attrs.focusElement, function(value) {
          if (value === true) {
            $timeout(() => {
              element[0].focus();
              scope[attrs.focusElement] = false;
            });
          }
        });
      }
    };
  }
];



// WEBPACK FOOTER //
// ./source/client/layout-components/focus-element/focus-element.dir.js